import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  ADD_GET_ALL_PETS,
  ADDRESS,
  CUSTOMER_PROFILE,
  CUSTOMER_SUBSCRIPTION,
  GET_WALLET,
  UPLOAD_CUSTOMER_FILE,
  WALLET_TRANSACTIONS_HISTROY,
} from "../../../config/apiUrlsCustomer";
import {
  IAddressRequest,
  ICreatePetProfileRequest,
  IUpdateSubBillingCycleRequest,
  IUpdateSubQuantityRequest,
  IUpdateSubVariantRequest,
  IUserProfileRequest,
} from "../../../types/Request/CustomerRequest";
import {
  IAddressResponse,
  IAllGetPetsResponse,
  IContactUsDetails,
  ICreatePetResponse,
  ICustomerSubscriptionDashboardSummary,
  ICustomerSubscriptionDetailsResponse,
  IGetAddressResponse,
  IMySubscriptionListResponse,
  ISubscriptionPriceSummary,
  IUserProfileResponse,
  IWalletSummary,
  MyReferralApiResponse,
  MyReferralResponse,
  WalletTransactionResponse,
} from "../../../types/Response/CustomerResponse";
import { IUploadFileRequest } from "../../../types/Request/AdminRequest";
import { IUploadFileResponse } from "../../../types/Response/AdminResponse";

export const customerProfileAPi = createApi({
  reducerPath: "customerProfileAPi",
  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    upsertUserProfile: builder.mutation<
      IUserProfileResponse,
      IUserProfileRequest
    >({
      query: (data) => ({
        url: `${CUSTOMER_PROFILE}`,
        method: "post",
        data: data,
      }),
    }),

    getUserProfile: builder.query<IUserProfileResponse, void>({
      query: () => ({
        url: `${CUSTOMER_PROFILE}`,
        method: "get",
      }),
    }),
    getPetProfile: builder.query<IAllGetPetsResponse, void>({
      query: () => ({
        url: `${ADD_GET_ALL_PETS}`,
        method: "get",
      }),
    }),
    createUserProfile: builder.mutation<
      ICreatePetResponse,
      ICreatePetProfileRequest
    >({
      query: (data) => ({
        url: `${ADD_GET_ALL_PETS}`,
        method: "post",
        data: data,
      }),
    }),
    UpdatePetProfile: builder.mutation<
      ICreatePetResponse,
      { petId: number; data: ICreatePetProfileRequest }
    >({
      query: ({ petId, data }) => ({
        url: `${ADD_GET_ALL_PETS}/${petId}`,
        method: "put",
        data: data,
      }),
    }),
    getPetProfileById: builder.query<ICreatePetResponse, number>({
      query: (id) => ({
        url: `${ADD_GET_ALL_PETS}/${id}`,
        method: "get",
      }),
    }),

    UpdateAddress: builder.mutation<
      ICreatePetResponse,
      { addressId: number; data: IAddressRequest }
    >({
      query: ({ addressId, data }) => ({
        url: `${ADDRESS}/${addressId}`,
        method: "put",
        data: data,
      }),
    }),
    createAddress: builder.mutation<IAddressResponse, IAddressRequest>({
      query: (data) => ({
        url: `${ADDRESS}`,
        method: "post",
        data: data,
      }),
    }),
    getAddressById: builder.query<IAddressResponse, number>({
      query: (id) => ({
        url: `${ADDRESS}/${id}`,
        method: "get",
      }),
    }),
    deleteAddressById: builder.query<IAddressResponse, number>({
      query: (id) => ({
        url: `${ADDRESS}/${id}`,
        method: "delete",
      }),
    }),
    getAddress: builder.query<IGetAddressResponse, void>({
      query: () => ({
        url: `${ADDRESS}`,
        method: "get",
      }),
    }),

        GetWallet: builder.query<IWalletSummary, void>({
          query: () => ({
            url: GET_WALLET,
            method: "get",
          }),
        }),
           GetWalletHistory: builder.query<WalletTransactionResponse, void>({
          query: () => ({
            url: WALLET_TRANSACTIONS_HISTROY,
            method: "get",
          }),
        }),


       MySubscription: builder.query<IMySubscriptionListResponse, void>({
          query: () => ({
            url: `${CUSTOMER_SUBSCRIPTION}/my`,
            method: "get",
          }),
        }),

         customerSubscriptionDashboard: builder.query<ICustomerSubscriptionDashboardSummary, void>({
          query: () => ({
            url: `${CUSTOMER_SUBSCRIPTION}/dashboard`,
            method: "get",
          }),
        }),

         getSubscriptionById: builder.query<ICustomerSubscriptionDetailsResponse, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}`,
            method: "get",
          }),
        }),

            pauseSubscription: builder.mutation<void, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/pause`,
            method: "put",
          }),
        }),
            resumeSubscription: builder.mutation<void, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/resume`,
            method: "put",
          }),
        }),
                 cancelSubscription: builder.mutation<void, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/cancel`,
            method: "put",
          }),
        }),
                SkipNextDeliverySubscription: builder.mutation<void, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/skip-next-delivery`,
            method: "put",
          }),
        }),
          toggleAutoRenewSubscription: builder.mutation<void, number>({
          query: (id) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/toggle-auto-renew`,
            method: "put",
          }),
        }),
        updateSubscriptionQuantity: builder.mutation<void, {id:number,data:IUpdateSubQuantityRequest}>({
          query: ({id,data}) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/quantity`,
            method: "put",
            data:data
          }),
        }),
            ChangeBlilingCycle: builder.mutation<void, {id:number,data:IUpdateSubBillingCycleRequest}>({
          query: ({id,data}) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/billing`,
            method: "put",
            data:data
          }),
        }),
          ChangeSubVariant: builder.mutation<void, {id:number,data:IUpdateSubVariantRequest}>({
          query: ({id,data}) => ({
            url: `${CUSTOMER_SUBSCRIPTION}/${id}/variant`,
            method: "put",
            data:data
          }),
        }),

         customerSubscriptionPreview: builder.query<ISubscriptionPriceSummary, void>({
          query: () => ({
            url: `${CUSTOMER_SUBSCRIPTION}/preview`,
            method: "get",
          }),
        }),

                 GetMyReferrals: builder.query<MyReferralApiResponse, void>({
          query: () => ({
            url: `${CUSTOMER_PROFILE}/referrals`,
            method: "get",
          }),
        }),

        
                 ContactUsDetails: builder.query<IContactUsDetails, void>({
          query: () => ({
            url: `${CUSTOMER_PROFILE}/contact-us`,
            method: "get",
          }),
        }),

    uploadCustomerFile: builder.mutation<IUploadFileResponse, IUploadFileRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append("file", data.File);
        formData.append("folderName", data.FolderName);
        return {
          url: UPLOAD_CUSTOMER_FILE,
          method: "post",
          data: formData,
        };
      },
    }),


    
  }),
});

export const {
  useUpsertUserProfileMutation,
  useLazyGetUserProfileQuery,
  useLazyGetPetProfileQuery,
  useCreateUserProfileMutation,
  useUpdatePetProfileMutation,
  useLazyGetPetProfileByIdQuery,
  useLazyGetAddressByIdQuery,
  useLazyGetAddressQuery,
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useLazyDeleteAddressByIdQuery,
  useLazyGetWalletHistoryQuery,
  useLazyGetWalletQuery,



  useLazyCustomerSubscriptionDashboardQuery,
  useLazyGetSubscriptionByIdQuery,
  useLazyMySubscriptionQuery,

  useCancelSubscriptionMutation,
  useChangeBlilingCycleMutation,
  useChangeSubVariantMutation,
  useLazyCustomerSubscriptionPreviewQuery,
  usePauseSubscriptionMutation,
  useResumeSubscriptionMutation,
  useUpdateSubscriptionQuantityMutation,
  useToggleAutoRenewSubscriptionMutation,
  useSkipNextDeliverySubscriptionMutation,
  useUploadCustomerFileMutation,
  useLazyGetMyReferralsQuery,
  useLazyContactUsDetailsQuery


  
} = customerProfileAPi;
